export const SERIAL_REGEX = /^(\d{4})(0[1-9]|1[0-2])(\d{8})$/

export type RetentionValidationResult = {
  isValid: boolean
  message: string
}

export const retentionLabels: Record<string, string> = {
  retIva75: "IVA 75%",
  retISLR2: "ISLR 2%",
  retISLR3: "ISLR 3%",
}

export const validateRetention = (params: {
  retainedValue: string
  serialNumber: string
  pdf: File | null
  valorSugerido: number
  tolerance: number
  label: string
}): RetentionValidationResult => {
  const { retainedValue, serialNumber, pdf, valorSugerido, tolerance, label } =
    params

  if (retainedValue === "" || retainedValue === ",") {
    return {
      isValid: false,
      message: `${label}: Falta ingresar el valor retenido`,
    }
  }

  const normalized = retainedValue.replace(",", ".")
  const numericValue = Number(normalized)
  const toleranciaValor = valorSugerido * (tolerance / 100)
  const min = valorSugerido - toleranciaValor
  const max = valorSugerido + toleranciaValor

  if (isNaN(numericValue) || numericValue < min || numericValue > max) {
    return {
      isValid: false,
      message: `${label}: El valor retenido está fuera del rango permitido`,
    }
  }

  if (serialNumber === "") {
    return { isValid: false, message: `${label}: Falta ingresar el serial` }
  }

  if (serialNumber.length !== 14) {
    return {
      isValid: false,
      message: `${label}: El serial debe tener 14 dígitos`,
    }
  }

  const match = serialNumber.match(SERIAL_REGEX)
  if (!match) {
    return {
      isValid: false,
      message: `${label}: Serial inválido (formato: año(4) + mes(2) + serial(8))`,
    }
  }

  const year = Number(match[1])
  const currentYear = new Date().getFullYear()
  if (year < currentYear - 100 || year > currentYear + 100) {
    return {
      isValid: false,
      message: `${label}: El año del serial está fuera de rango`,
    }
  }

  if (!pdf) {
    return {
      isValid: false,
      message: `${label}: Falta cargar el comprobante PDF`,
    }
  }

  return { isValid: true, message: "" }
}
